import { defineStore } from 'pinia'
import { ref } from 'vue'

// 待反馈错误码
export const PENDING_FEEDBACK_ERROR_CODE = 1100011022

export const useImageFeedbackStore = defineStore('imageFeedback', () => {
  // 是否显示反馈收集器
  const showFeedbackCollector = ref(false)

  // 待反馈的错误消息
  const pendingFeedbackMessage = ref('')

  // 是否正在等待用户反馈（用于其他模块判断是否需要继续处理错误）
  const isWaitingFeedback = ref(false)

  // 打开反馈收集器
  const openFeedbackCollector = (message) => {
    pendingFeedbackMessage.value = message || '存在未反馈的生图结果，请先完成反馈后再继续操作。'
    showFeedbackCollector.value = true
    isWaitingFeedback.value = true
  }

  // 关闭反馈收集器
  const closeFeedbackCollector = () => {
    showFeedbackCollector.value = false
    pendingFeedbackMessage.value = ''
    isWaitingFeedback.value = false
  }

  // 反馈完成
  const onFeedbackCompleted = () => {
    showFeedbackCollector.value = false
    pendingFeedbackMessage.value = ''
    isWaitingFeedback.value = false
  }

  return {
    showFeedbackCollector,
    pendingFeedbackMessage,
    isWaitingFeedback,
    openFeedbackCollector,
    closeFeedbackCollector,
    onFeedbackCompleted
  }
})